export class Friend {
  id: string;
  nickName: string;
  friendship: Friendship;
}

export class Friends {
  friendsCount: number;
  friends: Friend[];

  pendingFriendsCount: number;
  pendingFriends: Friend[];
}

export enum Friendship {
  Unfriend = 0,
  Friend = 1,
  PendingFriend = 2,
  PendingRequest = 3,
}
